
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import config from "@/config";
import { getFormatDate } from "@/common/utils";
import { pageViewUnit } from "@/config";
import { isCollection, addCollection, deleteCollection } from "@/api/policy";
import Share from "vue-social-share";
import cookie from "js-cookie";
import "vue-social-share/dist/client.css";

@Component({
  name: "Publicy",
  components: { Share },
})
export default class Publicy extends Vue {
  @Action("policy/getPublicyData") private getPolicyData: any;
  @Action("policy/addPublicyPageView") private addPolicyView: any;
  pageViewUnit = pageViewUnit;
  pageData: any = {};
  publicyId: any = this.$route.query.publicyId;
  file: any = [];
  shareConfig: any = { show: false };
  isCollection: Boolean = false;
  created() {
    // this.addPolicyView(this.publicyId);
    this.getData();
  }
  download({ url }: any) {
    window.open(url);
  }
  getData() {
    if (cookie.get("accessToken")) {
      isCollection({
        type: "policy",
        id: this.publicyId,
      }).then((res) => {
        this.isCollection = res.data.result;
      });
    }
    this.getPolicyData(this.publicyId).then(({ code, result, msg }: any) => {
      if (code === 200) {
        let data = result;
        const baseURL =
          process.env.NODE_ENV === "development"
            ? config.basicUrl
            : `${location.origin}/`;
        const { enclosureVoList } = data;
        this.shareConfig = {
          show: true,
          url:
            config.h5Url + "#/policy/details?id=" + this.$route.query.publicyId,
          source: "黄石政策计算器",
          title: data.title,
          // description: "woshfif",
          sites: ["wechat", "qq", "weibo"],
          wechatQrcodeTitle: "微信扫一扫：分享",
          wechatQrcodeHelper:
            "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
        };
        data.releaseDate = getFormatDate(data.releaseDate);
        // data.year = data.pubDate.slice(0, 4);
        this.pageData = data;
        if (enclosureVoList && enclosureVoList.length > 0) {
          this.file = enclosureVoList.map(
            ({ enclosureName, enclosureUrl }: any) => {
              const name =
                enclosureName.split("-")[enclosureName.split("-").length - 1];
              const baseURL =
                process.env.NODE_ENV === "development"
                  ? config.basicUrl
                  : `${location.origin}/`;
              const url = `${baseURL}zst/user/file/downloadFile?filePath=${encodeURIComponent(
                enclosureUrl
              )}`;
              return { name, url };
            }
          );
        }
      }
      return data;
    });
  }
  adEvent() {
    if (cookie.get("accessToken")) {
      addCollection({
        type: "policy",
        id: this.publicyId,
      }).then((res) => {
        this.$message.success("收藏成功");
        this.isCollection = true;
      });
    } else {
      this.$message.warning("请先登录!");
    }
  }
  delEvent() {
    deleteCollection({
      type: "policy",
      id: this.publicyId,
    }).then((res) => {
      this.$message("取消收藏");
      this.isCollection = false;
    });
  }
}
